import { render, staticRenderFns } from "./UserApprove.vue?vue&type=template&id=55fa4ad9&"
import script from "./UserApprove.vue?vue&type=script&lang=js&"
export * from "./UserApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports